// Generated from grammarParser.g4 by ANTLR 4.7.2
// jshint ignore: start
var antlr4 = require("antlr4/index");

// This class defines a complete listener for a parse tree produced by grammarParser.
function grammarParserListener() {
  antlr4.tree.ParseTreeListener.call(this);

  return this;
}

grammarParserListener.prototype = Object.create(
  antlr4.tree.ParseTreeListener.prototype
);
grammarParserListener.prototype.constructor = grammarParserListener;

// Enter a parse tree produced by grammarParser#compilationUnit.
grammarParserListener.prototype.enterCompilationUnit = function () {};

// Exit a parse tree produced by grammarParser#compilationUnit.
grammarParserListener.prototype.exitCompilationUnit = function () {};

// Enter a parse tree produced by grammarParser#initialSetence.
grammarParserListener.prototype.enterInitialSetence = function () {};

// Exit a parse tree produced by grammarParser#initialSetence.
grammarParserListener.prototype.exitInitialSetence = function () {};

// Enter a parse tree produced by grammarParser#setenses.
grammarParserListener.prototype.enterSetenses = function () {};

// Exit a parse tree produced by grammarParser#setenses.
grammarParserListener.prototype.exitSetenses = function () {};

// Enter a parse tree produced by grammarParser#moreSetences.
grammarParserListener.prototype.enterMoreSetences = function () {};

// Exit a parse tree produced by grammarParser#moreSetences.
grammarParserListener.prototype.exitMoreSetences = function () {};

exports.grammarParserListener = grammarParserListener;
